export const MAP_OUTLINE_POINTS =
  '667.92,0.49 1399.97,363.7 700.32,718.97 0.33,360.98';

export const ZONES = [
  {
    id: 'biomed',
    title: 'Биомед',
    href: 'clusters?cluster=biomed',
    points:
      '662.2, 135.45 662.2, 30.1 722.4, 0 887.95, 90.3 887.95, 180.6 827.75, 210.7',
  },
  {
    id: 'infotekh',
    title: 'Инфотех',
    href: 'clusters?cluster=infotekh',
    points:
      '466.55, 225.75 466.55, 120.4 617.05, 60.2 767.55, 135.45 767.55, 240.8 632.1, 301',
  },
  {
    id: 'kosmos',
    title: 'Космос',
    href: 'clusters?cluster=kosmos',
    points:
      '240.8, 316.05 240.8, 225.75 391.3, 150.5 421.4, 165.55 421.4, 225.75 436.45, 240.8 496.65, 210.7 541.8, 233.275 541.8, 331.1 406.35, 391.3',
  },
  {
    id: 'obrazovatelnyy',
    title: 'Образовательный',
    href: 'clusters?cluster=obrazovatelnyy',
    points:
      '361.2, 451.5 361.2, 421.4 391.3, 406.35 391.3, 285.95 466.55, 255.85 466.55, 376.25 496.65, 353.675 556.85, 383.775 556.85, 421.4 421.4, 481.6',
  },
  {
    id: 'nanotekh',
    title: 'Нанотех',
    href: 'clusters?cluster=nanotekh',
    points:
      '903, 285.95 903, 195.65 1023.4, 135.45 1173.9, 195.65 1173.9, 301 1053.5, 361.2',
  },
  {
    id: 'inzhiniring',
    title: 'Инжиниринг',
    href: 'clusters?cluster=inzhiniring',
    points:
      '722.4, 361.2 722.4, 270.9 782.6, 240.8 842.8, 285.95 903, 255.85 1038.45, 331.1 1038.45, 361.2 993.3, 391.3 948.15, 376.25 842.8, 421.4',
  },
  {
    id: 'geotekh',
    title: 'Геотех',
    href: 'clusters?cluster=geotekh',
    points:
      '496.65, 511.7 496.65, 466.55 564.375, 436.45 564.375, 376.25 602, 361.2 647.15, 391.3 692.3, 361.2 737.45, 391.3 737.45, 451.5 782.6, 481.6 782.6, 511.7 647.15, 586.95',
  },
  {
    id: 'mezhdistsiplinarnyy',
    title: 'Междисциплинарный',
    href: 'clusters?cluster=mezhdistsiplinarnyy',
    points:
      '963.2, 466.55 963.2, 436.45 1143.8, 346.15 1143.8, 301 1264.2, 240.8 1399.65, 316.05 1399.65, 406.35 1128.75, 549.325',
  },
  {
    id: 'lomonosov',
    title: 'Ломоносов',
    href: 'clusters?cluster=lomonosov',
    points:
      '654.675, 677.25 662.2, 602 692.3, 586.95 692.3, 549.325 722.4, 534.275 797.65, 526.75 827.75, 511.7 842.8, 481.6 887.95, 466.55 887.95, 436.45 918.05, 406.35 1038.45, 481.6 1038.45, 571.9 797.65, 692.3 722.4, 707.35',
  },
];

function parsePolygonCentroid(points: string): { x: number; y: number } | null {
  const nums = points.match(/-?[\d.]+/g)?.map(Number) ?? [];
  if (nums.length < 2) return null;
  let sx = 0;
  let sy = 0;
  let n = 0;
  for (let i = 0; i + 1 < nums.length; i += 2) {
    sx += nums[i];
    sy += nums[i + 1];
    n += 1;
  }
  if (!n) return null;
  return { x: sx / n, y: sy / n };
}

export function getZoneCentroidById(zoneId: string): { x: number; y: number } | null {
  const z = ZONES.find((item) => item.id === zoneId);
  if (!z) return null;
  return parsePolygonCentroid(z.points);
}

export const ZONES_IMG = [
  {
    id: 'obrazovatelnyy',
    layerId: 'educational',
    title: 'Образовательный',
  },
  {
    id: 'kosmos',
    layerId: 'cosmos',
    title: 'Космос',
  },
  {
    id: 'infotekh',
    layerId: 'infotech',
    title: 'Инфотех',
  },
  {
    id: 'biomed',
    title: 'Биомед',
  },
  {
    id: 'nanotekh',
    layerId: 'nanotech',
    title: 'Нанотех',
  },
  {
    id: 'inzhiniring',
    layerId: 'engineering',
    title: 'Инжиниринг',
  },
  {
    id: 'geotekh',
    layerId: 'geotech',
    title: 'Геотех',
  },
  {
    id: 'mezhdistsiplinarnyy',
    layerId: 'interdisciplinary',
    title: 'Междисциплинарный',
  },
  {
    id: 'lomonosov',
    title: 'Ломоносов',
  },
];
